import { render, staticRenderFns } from "./Bildirimler.vue?vue&type=template&id=8ffaa3f6&"
import script from "./Bildirimler.vue?vue&type=script&lang=js&"
export * from "./Bildirimler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports